import styled from "styled-components"
import * as styleVars from "../variable"

export const BgStyles = styled.section`
  margin-bottom: 60px;
  background: ${styleVars.hackBlack5};
  border-bottom: 20px solid #1f244d;
`

export default BgStyles
